import React, { useState } from 'react';
import { Search, Eye } from 'lucide-react';

const accent = '#6366f1';
const accentLight = '#f1f5ff';

const initialData = [
  { id: 1, chatbotId: 'CB-001', agentName: 'Alice', totalCost: '$12.50', chatHistory: 'View' },
  { id: 2, chatbotId: 'CB-002', agentName: 'Bob', totalCost: '$8.20', chatHistory: 'View' },
  { id: 3, chatbotId: 'CB-003', agentName: 'Charlie', totalCost: '$15.00', chatHistory: 'View' },
  { id: 4, chatbotId: 'CB-004', agentName: 'Diana', totalCost: '$5.75', chatHistory: 'View' },
  { id: 5, chatbotId: 'CB-005', agentName: 'Eve', totalCost: '$20.00', chatHistory: 'View' },
  { id: 6, chatbotId: 'CB-006', agentName: 'Frank', totalCost: '$7.30', chatHistory: 'View' },
  { id: 7, chatbotId: 'CB-007', agentName: 'Grace', totalCost: '$9.80', chatHistory: 'View' },
  { id: 8, chatbotId: 'CB-008', agentName: 'Heidi', totalCost: '$11.10', chatHistory: 'View' },
  { id: 9, chatbotId: 'CB-009', agentName: 'Ivan', totalCost: '$6.60', chatHistory: 'View' },
  { id: 10, chatbotId: 'CB-010', agentName: 'Judy', totalCost: '$13.40', chatHistory: 'View' },
  { id: 11, chatbotId: 'CB-011', agentName: 'Karl', totalCost: '$10.00', chatHistory: 'View' },
  { id: 12, chatbotId: 'CB-012', agentName: 'Laura', totalCost: '$14.25', chatHistory: 'View' },
];

const ChatHistory = () => {
  const [data] = useState(initialData);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const filteredData = data.filter(row =>
    row.chatbotId.toLowerCase().includes(searchTerm.toLowerCase()) ||
    row.agentName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentRows = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  return (
    <div style={{ 
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif', 
      background: '#fafbfc', 
      minHeight: '100vh',
      padding: '2rem 1.5rem',
      width: '100%',
      boxSizing: 'border-box'
    }}>
      {/* Header Section */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginBottom: '.5rem' }}>
        <div>
          <h1 className="fw-bold mb-2" style={{ color: '#1f2937', fontSize: '1.75rem', letterSpacing: '-0.025em' }}>Chat History</h1>
          <p className="text-muted mb-0" style={{ fontSize: '0.875rem' }}>View chatbot conversations and costs</p>
        </div>
      </div>

      {/* Stats Cards */}
      <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap', marginBottom: '.5rem' }}>
        <div style={{ flex: '1 1 180px', minWidth: 0 }}>
          <div className="card border-0 shadow-sm h-100" style={{ background: '#fff', borderRadius: '12px', width: '100%' }}>
            <div className="card-body p-3 p-md-4">
              <div className="d-flex align-items-center">
                <div style={{ width: 40, height: 40, background: accentLight, borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <span style={{ color: accent, fontSize: '1rem', fontWeight: '600' }}>{data.length}</span>
                </div>
                <div style={{ marginLeft: 12 }}>
                  <h6 className="mb-1 fw-semibold" style={{ color: '#1f2937', fontSize: '0.875rem' }}>Total Chats</h6>
                  <p className="mb-0 text-muted" style={{ fontSize: '0.75rem' }}>All conversations</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ flex: '1 1 180px', minWidth: 0 }}>
          <div className="card border-0 shadow-sm h-100" style={{ background: '#fff', borderRadius: '12px', width: '100%' }}>
            <div className="card-body p-3 p-md-4">
              <div className="d-flex align-items-center">
                <div style={{ width: 40, height: 40, background: '#f0fdf4', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <span style={{ color: '#16a34a', fontSize: '1rem', fontWeight: '600' }}>${data.reduce((sum, row) => sum + parseFloat(row.totalCost.replace('$', '')), 0).toFixed(2)}</span>
                </div>
                <div style={{ marginLeft: 12 }}>
                  <h6 className="mb-1 fw-semibold" style={{ color: '#1f2937', fontSize: '0.875rem' }}>Total Cost</h6>
                  <p className="mb-0 text-muted" style={{ fontSize: '0.75rem' }}>All expenses</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ flex: '1 1 180px', minWidth: 0 }}>
          <div className="card border-0 shadow-sm h-100" style={{ background: '#fff', borderRadius: '12px', width: '100%' }}>
            <div className="card-body p-3 p-md-4">
              <div className="d-flex align-items-center">
                <div style={{ width: 40, height: 40, background: '#f0f9ff', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <span style={{ color: '#0284c7', fontSize: '1rem', fontWeight: '600' }}>{filteredData.length}</span>
                </div>
                <div style={{ marginLeft: 12 }}>
                  <h6 className="mb-1 fw-semibold" style={{ color: '#1f2937', fontSize: '0.875rem' }}>Filtered Results</h6>
                  <p className="mb-0 text-muted" style={{ fontSize: '0.75rem' }}>Search results</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Search and Filters */}
      <div className="card border-0 shadow-sm mb-4" style={{ background: '#fff', borderRadius: '12px', width: '100%' }}>
        <div className="card-body p-3 p-md-4">
          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '1rem' }}>
            <div style={{ flex: 1, minWidth: 220 }}>
              <div className="position-relative">
                <Search 
                  size={18} 
                  style={{ color: '#9ca3af', position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', zIndex: 1 }} 
                />
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by chatbot ID or agent name..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', paddingLeft: '48px', fontSize: '0.875rem' }}
                />
              </div>
            </div>
            <div style={{ minWidth: 180, textAlign: 'right', flex: 'none' }}>
              <span className="text-muted" style={{ fontSize: '0.875rem' }}>
                Showing {filteredData.length} of {data.length} records
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Chat History Table */}
      <div className="card border-0 shadow-sm" style={{ background: '#fff', borderRadius: '12px', overflow: 'hidden', width: '100%' }}>
        <div className="table-responsive">
          <table className="table mb-0" style={{ width: '100%' }}>
            <thead style={{ background: '#f8fafc' }}>
              <tr>
                <th className="border-0 fw-semibold text-muted py-2 px-2" style={{ fontSize: '0.875rem' }}>
                  Chatbot ID
                </th>
                <th className="border-0 fw-semibold text-muted py-2 px-2" style={{ fontSize: '0.875rem' }}>
                  Agent Name
                </th>
                <th className="border-0 fw-semibold text-muted py-2 px-2" style={{ fontSize: '0.875rem' }}>
                  Total Cost
                </th>
                <th className="border-0 fw-semibold text-muted py-2 text-end px-2" style={{ fontSize: '0.875rem' }}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {currentRows.map((row, index) => (
                <tr key={row.id} style={{ borderBottom: index === currentRows.length - 1 ? 'none' : '1px solid #f1f5f9' }}>
                  <td className="py-2 px-2">
                    <div className="d-flex align-items-center gap-2">
                      <div style={{ width: 32, height: 32, background: `linear-gradient(135deg, ${accent} 0%, #8b5cf6 100%)`, color: '#fff', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '600', fontSize: '0.875rem', flexShrink: 0 }}>
                        {row.chatbotId.charAt(0)}
                      </div>
                      <div>
                        <div className="fw-semibold" style={{ color: '#1f2937', fontSize: '0.875rem' }}>
                          {row.chatbotId}
                        </div>
                        <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                          ID: {row.id}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="py-2 px-2">
                    <span style={{ color: '#374151', fontSize: '0.875rem' }}>
                      {row.agentName}
                    </span>
                  </td>
                  <td className="py-2 px-2">
                    <span className="badge px-2 py-1 rounded-pill fw-semibold" style={{ background: '#f0fdf4', color: '#16a34a', fontSize: '0.75rem' }}>
                      {row.totalCost}
                    </span>
                  </td>
                  <td className="py-2 text-end px-2">
                    <button 
                      className="btn btn-sm rounded-pill border-0"
                      style={{ 
                        color: accent, 
                        background: accentLight,
                        padding: '4px 12px',
                        fontSize: '0.75rem'
                      }}
                      title="View Chat History"
                    >
                      <Eye size={12} className="me-1" />
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        {/* Pagination */}
        <div className="card-footer bg-white border-0 py-3 py-md-4">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
            <div className="text-muted text-center text-md-start" style={{ fontSize: '0.875rem' }}>
              Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredData.length)} of {filteredData.length} results
            </div>
            <nav aria-label="Chat history pagination">
              <ul className="pagination mb-0 gap-1">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button 
                    className="page-link border-0 px-2 px-md-3 py-2 rounded"
                    style={{ 
                      color: currentPage === 1 ? '#9ca3af' : accent,
                      background: 'transparent',
                      fontSize: '0.875rem'
                    }}
                    onClick={() => setCurrentPage(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    <span className="d-none d-sm-inline">Previous</span>
                    <span className="d-sm-none">‹</span>
                  </button>
                </li>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                  <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                    <button 
                      className={`page-link border-0 px-2 px-md-3 py-2 rounded fw-semibold${currentPage === page ? '' : ''}`}
                      style={{ 
                        color: currentPage === page ? '#fff' : accent, 
                        background: currentPage === page ? accent : 'transparent',
                        fontSize: '0.875rem'
                      }}
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </button>
                  </li>
                ))}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button 
                    className="page-link border-0 px-2 px-md-3 py-2 rounded"
                    style={{ 
                      color: currentPage === totalPages ? '#9ca3af' : accent,
                      background: 'transparent',
                      fontSize: '0.875rem'
                    }}
                    onClick={() => setCurrentPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    <span className="d-none d-sm-inline">Next</span>
                    <span className="d-sm-none">›</span>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatHistory; 